import type { MRT_RowData, MRT_TableOptions } from "material-react-table";
import { MRT_Localization_CS } from "material-react-table/locales/cs";

export const getDefaultTableOptions = <TData extends MRT_RowData>(): Partial<
	MRT_TableOptions<TData>
> => ({
	enableTopToolbar: false,
	localization: MRT_Localization_CS,
});

// This can be used as custom component, but it's not recommended by MRT author

// interface Props<TData extends MRT_RowData> extends MRT_TableOptions<TData> {
// 	columns: MRT_ColumnDef<TData>[];
// 	data: TData[];
// }

// export const BlDataTable = <TData extends MRT_RowData>({
// 	columns,
// 	data,
// 	...rest
// }: Props<TData>) => {
// 	const table = useMaterialReactTable({
// 		columns,
// 		data,
// 		enableTopToolbar: false,
// 		muiTableBodyProps: {
// 			sx: {
// 				"& tr:nth-of-type(odd) > td": {
// 					backgroundColor: "#E2E8F0",
// 				},
// 			},
// 		},
// 		localization: MRT_Localization_CS,
// 		...rest,
// 	});

// 	return <MaterialReactTable table={table} />;
// };
